import React from 'react';
import { SetUpDeviceExpandToken } from './';

interface IProps {
    isNeedExpandToken: boolean;
    encodedKey: string;
}

export const SetUpDeviceManualToken: React.SFC<IProps> = ({
    isNeedExpandToken,
    encodedKey,
}) => {
    return (
        <>
            <SetUpDeviceExpandToken
                encodedKey={encodedKey}
                isNeedExpandToken={isNeedExpandToken}
            />
        </>
    );
};
